"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var raw = require("core-js-pure/features/string/raw");
var React = require("react");
var Bcp47 = require("bcp-47");
var memoize = require("lodash.memoize");
exports.getInitialI18nState = function () { return ({
    translations: {},
    locale: null,
}); };
exports.i18nContext = React.createContext(exports.getInitialI18nState());
var _useTextCache = new Map();
exports.useLocale = function () {
    var locale = React.useContext(exports.i18nContext).locale;
    if (!locale) {
        throw new Error('locale not found');
    }
    return locale;
};
exports.useLocaleString = function () {
    var locale = exports.useLocale();
    return exports.toLocaleString(locale);
};
exports.useTexts = function (locale) {
    var _a = React.useContext(exports.i18nContext), translations = _a.translations, contextLocale = _a.locale;
    if (!locale && !contextLocale) {
        throw new Error('locale not found');
    }
    var localeString = exports.toLocaleString(locale || contextLocale);
    if (!_useTextCache.get(translations)) {
        _useTextCache.set(translations, {});
    }
    var cached = _useTextCache.get(translations);
    var cachedGetText = cached[localeString];
    if (cachedGetText) {
        return cachedGetText;
    }
    var getText = function (literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        var key = raw.apply(void 0, [literals].concat(placeholders));
        if (!translations[localeString] || !translations[localeString][key]) {
            return key;
        }
        return translations[localeString][key];
    };
    return cached[localeString] = getText;
};
var defaultSchema = {
    extendedLanguageSubtags: [],
    variants: [],
    extensions: [],
    privateuse: [],
    irregular: null,
    regular: null,
};
exports.toLocaleString = function (localeObject) {
    return Bcp47.stringify(__assign({}, defaultSchema, localeObject));
};
exports.toLocaleObject = memoize(function (localeString) {
    var _a = Bcp47.parse(localeString), language = _a.language, _b = _a.script, script = _b === void 0 ? null : _b, _c = _a.region, region = _c === void 0 ? null : _c;
    return {
        language: language,
        script: script,
        region: region,
    };
});
